module.exports = __webpack_public_path__ + "img/mob-comment-bg-small.fda607e7.png";